import React, { useEffect, useState } from "react";
import { FaMicrophone } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import AnnouncementBox from "./AnnouncementBox";
import { setSiteDetails } from "../../../../AsianExchangeSrc/redux/slices/siteSlice";
import { getRefreshSitesByDomain } from "../../../../AsianExchangeSrc/api";

const parseNews = (newsHTML) => {
  const div = document.createElement("div");
  div.innerHTML = newsHTML;
  const span = div.querySelector(".news-time");
  const time = span?.textContent || "";
  span?.remove();
  const text = div.textContent?.trim() || "";
  return { time, text };
};

const News = () => {
  const siteNews = useSelector((state) => state?.site?.siteDetails?.news);
  const [showModal, setShowModal] = useState(false);
  const domainName = window.location.host;
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        const response = await getRefreshSitesByDomain(domainName);
        const siteDetails = response?.data?.siteDetails;
     

        if (siteDetails) {
          dispatch(setSiteDetails(siteDetails));
        } else {
          console.warn("No site details found for the current domain.");
        }
      } catch (error) {
        console.error("Failed to fetch site details:", error);
      }
    })();
  }, [dispatch]);

  return (
    <>
      {/* News Bar */}
      <div
        className="flex items-center py-0.5 text-[#6ac2ff] text-[11.5px] font-semibold overflow-hidden border-y border-white cursor-pointer"
        style={{
          backgroundImage: "linear-gradient(180deg, #2a3a43 27%, #1c282d 83%)",
        }}
        onClick={() => setShowModal(true)}
      >
        <div className="flex items-center px-2.5 pr-3 py-0.5 gap-1 sky-news">
          <FaMicrophone className="text-white" />
          <span className="text-white font-bold">News</span>
        </div>

        <div className="relative overflow-hidden whitespace-nowrap w-full">
          <div className="animate-marquee flex">
            {siteNews.length > 0 ? (
              <>
                {siteNews.map((item, index) => {
                  const { time, text } = parseNews(item);
                  return (
                    <div key={index} className="mr-4">
                      <span className="italic text-[#1c2834] bg-[#6ac2ff] px-2 py-[1px] rounded mr-2">
                        {time}
                      </span>
                      <span>{text}</span>
                    </div>
                  );
                })}
              </>
            ) : (
              <p>
                {" "}
                Welcome to <span className="text-[#198754]">{domainName} </span>
                ! Join thousands of players betting live, winning big, and
                enjoying the ultimate betting rush. Ready to play smart and win
                bigger? Let’s go!
              </p>
            )}
          </div>
        </div>
      </div>

      {showModal && siteNews && siteNews.length > 0 && (
        <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black bg-opacity-60 ">
          <div className="rounded-md max-w-md mx-auto p-4 relative ">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-[16px] right-[30px] text-[#ffb200] text-2xl font-bold"
            >
              ×
            </button>
            <AnnouncementBox siteNews={siteNews} />
          </div>
        </div>
      )}
    </>
  );
};

export default News;
